import { cloneDeep, set, unset } from 'lodash';
import React, { useEffect } from 'react';
import { useQueryClient } from 'react-query';

// stateKey is an array used with loadsh for nested cases

function useShareSet({ pageKey, stateKey = [], state }) {
  const queryClient = useQueryClient()

  useEffect(() => {
    const shareData = queryClient.getQueryData(['share-service', pageKey]) || {};

    // TODO: test for overwrite/render issues
    // const updatedData: any = cloneDeep(exportData);
    set(shareData, ['config', ...stateKey], state);

    queryClient.setQueryData(['share-service', pageKey], shareData);

    // remove data on unmount
    return () => {
      const queryData = queryClient.getQueryData(['share-service', pageKey]);
      unset(queryData, ['config', ...stateKey]);
      queryClient.setQueryData(['share-service', pageKey], queryData);
    }
  }, [queryClient, pageKey, stateKey, state]);
}

export default useShareSet;
